import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCross = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCross.dimensions.width} ${IconCross.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill="none"
        stroke={color || Color.premiumBlack}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
        d="m.5.5 4 4m-4 0 4-4"
      />
    </Svg>
  )
}

IconCross.dimensions = {
  width: 8,
  height: 8,
}

export default IconCross
